import angular from 'angular';
import HeaderCountryController from "./headercountry-controller";

let HeaderCountry = angular
    .module('HeaderCountry', [])
    .controller('HeaderCountryController', HeaderCountryController);

export default HeaderCountry;

